<template>
  <div class="industryManagement common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">部门名称：</div>
          <div class="content">
            <el-input v-model="form.deptName" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">基地名称：</div>
          <div class="content">
            <el-input v-model="form.name" placeholder="请输入" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
    </div>
    <commonTable ref="industryManagementTable" />
    <addActivityDialog
      :row-data="rowData"
      :add-industry-dialog-show="addActivityDialogShow"
      @dialogClose="dialogCloseHandle"
      @addActivityHandle="addActivityHandle"
      @editActivityHandle="editActivityHandle"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { activityBaseApi } from './service';
import addActivityDialog from './component/activityBase/addActivityDialog';

export default {
  data () {
    return {
      form: {},
      addActivityDialogShow: false,
      rowData: {},
      stateList: [
        {
          label: '全部'
        },
        {
          label: '启用',
          val: 1
        },
        {
          label: '禁用',
          val: 0
        }
      ]
    };
  },
  components: {
    commonTable,
    addActivityDialog
  },
  methods: {
    addActivityHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      activityBaseApi.getActivityBase(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.addActivityDialogShow = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editActivityHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      activityBaseApi.setActivityBase(data).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.addActivityDialogShow = false;
          this.loadTable();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editHandlen (row) {
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addActivityDialogShow = true;
    },
    addBtn () {
      this.addActivityDialogShow = true;
    },
    dialogCloseHandle () {
      this.addActivityDialogShow = false;
      this.rowData = {};
    },
    searchBtn () {
      this.$refs.industryManagementTable.pageData.pageNum = 1;
      this.$refs.industryManagementTable.getTableData({ url: '/activity-base/list', params: this.form });
    },
    deleteHandle (row) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // 可查看用户删除
          activityBaseApi.delActivityBase(row.id).then(res => {
            if (res.status === '200') {
              this.$message.success('删除成功');
              this.searchBtn();
            }
          });
      }).catch(() => {

      });
    },
    reset () {
      this.form = {};
      this.searchBtn();
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('基地名称')
          ._width('10%')
          ._data('name')
      );
      tableRow.push(
        new TableColumns()
          ._title('所属部门')
          ._width('8%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建人')
          ._width('10%')
          ._data('createName')
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('10%')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('状态')
          ._data('stat')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-switch
                    value={ row.stat === 1 }
                    onChange={(res) => {
                      const params = {
                        id: row.id,
                        stat: res ? 1 : 0
                      };
                      activityBaseApi.setActivityBaseStatus(params).then(res => {
                        if (res.status === '200') {
                          this.loadTable();
                        }
                      });
                    }}
                    >
                  </el-switch>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('8%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.editHandlen(row); }}>
                    编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.industryManagementTable.setColumn(column);
      this.$refs.industryManagementTable.loadTable({ url: '/activity-base/list', listKey: 'list' });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>

<style scoped>
</style>
